<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row>
        <el-col :md="4" :lg="4">
          <el-input placeholder="手机号" v-model="invite_mobile" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="4" :lg="4">
          <el-input placeholder="货号" v-model="sku_bn" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="9" :lg="9">
          <el-date-picker v-model="created" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="dateChange" format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd" size="mini">
          </el-date-picker>
<!--          <el-button size="mini" type="primary" @click="exportData" v-loading="exportLoading" v-if="exportLoading == false">导出</el-button>-->
<!--          <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出</el-button>-->
          <el-button size="mini" type="primary" @click="exportViewOpen" v-loading="exportLoading" v-if="exportLoading == false">导出</el-button>
          <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表-优选分享点击’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-row>
      <el-dialog title="报表下载" :visible.sync="downloadView" :close-on-click-modal="false">
        <template v-if="downloadUrl">
          <a :href="downloadUrl" download>{{downloadName}}</a>
        </template>
      </el-dialog>
      <el-dialog title="报表设置" :visible.sync="exportView" :close-on-click-modal="false">
        <el-form>
          <el-form-item label-width="100px" label="报表名称">
            <el-input v-model="exportTitle" placeholder="报表名称"></el-input>
          </el-form-item>
          <el-form-item class="content-center">
            <el-button size="mini" type="primary" @click="exportData" v-loading="exportLoading" v-if="exportLoading == false">导出报表</el-button>
            <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出报表</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-table :data="clickData" :height="wheight-210" v-loading="loading"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
<!--        <el-table-column prop="id" label="ID" width="95"></el-table-column>-->
        <el-table-column prop="sku_name" label="商品名称" width="130"></el-table-column>
        <el-table-column prop="sku_id" label="商品ID" width="100"></el-table-column>
        <el-table-column prop="sku_bn" label="货号" width="130"></el-table-column>
        <el-table-column prop="share_total" label="分享数" width="70"></el-table-column>
        <el-table-column prop="click_total" label="点击数" width="70"></el-table-column>
        <el-table-column prop="user_id" label="怡贝会员ID" width="100"></el-table-column>
        <el-table-column prop="sharer_name" label="推广者姓名" width="100"></el-table-column>
        <el-table-column prop="sharer_mobile" label="推广者账号" width="120"></el-table-column>
        <el-table-column prop="updated_date" label="更新时间" width="190"></el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded tc">
        <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
        </el-pagination>
      </div>

    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {getClickList, clickExport} from '../../../api/sharer'
import {mapGetters} from "vuex";
export default {
  data () {
    return {
      total_count: 0,
      loading: false,
      exportLoading: false,
      clickData: [],
      params: {
        page: 1,
        pageSize: 20
      },
      exportTitle: '优选分享点击' + new Date().getTime(),
      exportView: false,
      downloadView: false,
      downloadUrl: '',
      downloadName: '',
      invite_mobile: '',
      sku_bn: '',
      created: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    // 默认时间
    timeDefault () {
      let date = new Date()
      // 通过时间戳计算
      let defalutStartTime = date.getTime() - 7 * 24 * 3600 * 1000 // 转化为时间戳
      let defalutEndTime = date.getTime()
      let startDateNs = new Date(defalutStartTime)
      let endDateNs = new Date(defalutEndTime)
      // 月，日 不够10补0
      defalutStartTime = startDateNs.getFullYear() + '-' + ((startDateNs.getMonth() + 1) >= 10 ? (startDateNs.getMonth() + 1) : '0' + (startDateNs.getMonth() + 1)) + '-' + (startDateNs.getDate() >= 10 ? startDateNs.getDate() : '0' + startDateNs.getDate())
      defalutEndTime = endDateNs.getFullYear() + '-' + ((endDateNs.getMonth() + 1) >= 10 ? (endDateNs.getMonth() + 1) : '0' + (endDateNs.getMonth() + 1)) + '-' + (endDateNs.getDate() >= 10 ? endDateNs.getDate() : '0' + endDateNs.getDate())
      this.params.time_start_begin = this.dateStrToTimeStamp(defalutStartTime + ' 00:00:00')
      this.params.time_start_end = this.dateStrToTimeStamp(defalutEndTime + ' 23:59:59')
      this.getItems(this.params)
      return [defalutStartTime, defalutEndTime]
    },
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    getItems (filter) {
      this.loading = true
      getClickList(filter).then(response => {
        this.clickData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
        this.exportLoading = false
      })
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getItems(this.params)
    },
    handleSelectionChange (val) {
      console.log(val)
    },
    getParams () {
      this.params.invite_mobile = this.invite_mobile
      this.params.sku_bn = this.sku_bn
      this.params.exportTitle = this.exportTitle
    },
    dateChange (val) {
      if (val && val.length > 0) {
        this.params.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
      this.params.page = 1
      // console.log(this.params)
      this.getItems(this.params)
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str)) / 1000
    },
    keywordsSearch (e) {
      this.params.page = 1
      this.getParams()
      this.getItems(this.params)
    },
    exportViewOpen () {
      this.exportView = true
    },
    exportData () {
      this.getParams()
      this.exportLoading = true
      this.exportView = false
      clickExport(this.params).then(response => {
        this.exportLoading = false
        if (response.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表-优选分享点击中下载'
          })
          return
        } else if (response.data.url) {
          this.downloadUrl = response.data.url
          this.downloadName = response.data.filename
          this.downloadView = true
        } else {
          this.$message({
            type: 'error',
            message: '无内容可导出 或 执行失败，请检查重试'
          })
          return
        }
      })
    }
  },
  created () {
    this.created = this.timeDefault
  },
  mounted () {
    this.getItems(this.params)
  },
  watch: {
    // 分页全选-监听数据变化
    clickData: {
      handler (value) {
        if (this.allCheck) {
          this.clickData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          })
        }
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// click_list.vue?35673804